import { Box, Typography, Paper, Divider, useTheme } from "@mui/material";
import DataGridMAIQ from "app/components/ReusableUIComponents/HighLevelComponents/DataGridMAIQ";
import DataGridTypes from "types/DataGridTypes";
import StoreIcon from '@mui/icons-material/Store';

const DealersTab = () => {
  const theme = useTheme();
  
  return (
    <Box 
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 3,
        height: "100%",
        padding: { xs: 1, sm: 2 }
      }}
    >
      <Paper 
        elevation={0}
        sx={{ 
          p: 2.5,
          display: "flex",
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: "space-between",
          alignItems: { xs: 'flex-start', sm: 'center' },
          borderRadius: 1.5,
          backgroundColor: 'background.paper',
          boxShadow: '0 2px 8px rgba(15, 40, 76, 0.05)',
          gap: 2
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <StoreIcon 
            sx={{ 
              color: theme.palette.primary.main,
              fontSize: 28 
            }} 
          />
          <Box>
            <Typography 
              variant="h6" 
              sx={{ 
                fontWeight: 600, 
                fontSize: '1.1rem',
                color: theme.palette.primary.main
              }}
            >
              Dealer Management
            </Typography>
            <Typography 
              variant="body2" 
              color="text.primary"
              sx={{ fontSize: '0.85rem' }}
            >
              View and manage dealer information
            </Typography>
          </Box>
        </Box>
      </Paper>
      
      <Divider sx={{ opacity: 0.5 }} />

      <Box sx={{ flexGrow: 1, minHeight: 300 }}>
        <DataGridMAIQ type={DataGridTypes.DEALERS_MANAGEMENT()} />
      </Box>
    </Box>
  );
};

export default DealersTab;